const SUPPORTED_DOCUMENTS_TYPES = Object.freeze({
    MAGAZINE: "MAGAZINE",
    ADDRESS_BOOK: "ADDRESS_BOOK",
  });

const AppConfig = {
    SUPPORTED_DOCUMENTS_TYPES
}

export default AppConfig;